import TomClient from "../../../anwendungskonfigurator/services/tomClient"
import {pathBuilder} from "../../../anwendungskonfigurator/misc/utils"

const mapSchadenData = (sourceData, einzelschadenListLength) => {
    const targetData = {
        schadennummer: einzelschadenListLength + 1,
        schadenjahr: sourceData.schadenjahr,
        deckung: [],
    }

    const coverageTypes = {
        gebaeude: "GEBAEUDE",
        inhalt: "INHALT",
        bu: "BU",
    }

    for (const key in coverageTypes) {
        if (
            sourceData[key] &&
            Array.isArray(sourceData[key]) &&
            sourceData[key].length > 0
        ) {
            sourceData[key].forEach((entry) => {
                targetData.deckung.push({
                    umfang: coverageTypes[key],
                    gefahr: entry,
                })
            })
        }
    }

    return targetData
}

const addZoneToRisikoort = (risikoort, akJson) => {
    const zone =
        akJson.data.enumerations
            .find((entry) => entry.label === "Zone")
            .children.find((entry) => entry.label === risikoort.postleitzahl)
            ?.value ?? 3
    return {...risikoort, bundeslandZone: zone}
}

const initRisikoortPage = (
    riskoortListResponse,
    updateData,
    getDataFromBackend,
    akJson,
) => {
    const defaultRisikoort =
        riskoortListResponse._data.length && riskoortListResponse._data[0]

    defaultRisikoort &&
        getDataFromBackend(
            defaultRisikoort._links.abweichungVersicherungsumfangLoad,
            "/risikoorte/risikoort/abweichung",
        )

    defaultRisikoort &&
        updateData(
            addZoneToRisikoort(defaultRisikoort, akJson),
            "/risikoorte/risikoort",
        )

    riskoortListResponse._data.map((risikoort, key) => {
        updateData(
            addZoneToRisikoort(risikoort, akJson),
            `/risikoorte/list/${key}`,
        )
    })

    Promise.all([
        getDataFromBackend(
            riskoortListResponse._links.adresseList,
            "/adressen/adresselist",
        ),
        defaultRisikoort &&
            getDataFromBackend(
                defaultRisikoort._links.einzelschadenList,
                "/schadenereignisse/ereignislist",
            ).then((response) =>
                updateData(
                    response._data.sort(
                        (a, b) => a.ereignisnummer - b.ereignisnummer,
                    ),
                    "/schadenereignisse/ereignislist",
                ),
            ),
    ])
}
const risikoortVersicherumsumfangArtGeneralPath =
    "/risikoorte/risikoort/abweichung/einzelgefahrList/[i]/versicherungsumfangArt"

export const RisikoortActions = ({
    getDataFromPointer,
    updateData,
    navigate,
    getDataFromBackend,
    sendDataToBackend,
    loadCurrentLocationData,
    akJson,
}) => {
    const toggleAll = (key, index, value) => {
        const currentPath = risikoortVersicherumsumfangArtGeneralPath.replace(
            "[i]",
            index,
        )
        const currentValue = getDataFromPointer(currentPath)
        if (value && !currentValue.includes(key)) {
            updateData([...currentValue, key], currentPath)
        } else if (!value && currentValue.includes(key)) {
            updateData(
                currentValue.filter((entry) => entry !== key),
                currentPath,
            )
        }
    }

    return {
        INIT_RISIKOORT: () => {
            loadCurrentLocationData("/risikoorte/list").then(
                (riskoortListResponse) =>
                    initRisikoortPage(
                        riskoortListResponse,
                        updateData,
                        getDataFromBackend,
                        akJson,
                    ),
            )
        },
        SAVE_RISIKOORT: () => {
            sendDataToBackend(
                getDataFromPointer(
                    "/risikoorte/risikoort/_links/risikoortSave",
                ),
                getDataFromPointer("/risikoorte/risikoort"),
            ).then(() => loadCurrentLocationData("/risikoorte/list"))
            sendDataToBackend(
                getDataFromPointer(
                    "/risikoorte/risikoort/abweichung/_links/abweichungVersicherungsumfang:update",
                ),
                getDataFromPointer("/risikoorte/risikoort/abweichung"),
            )
        },
        CREATE_RISIKOORT: (address) => {
            const risikoOrtListe = getDataFromPointer("/risikoorte/list")
            const amountOfRisikoorte = risikoOrtListe?.length ?? 0
            TomClient.callHallink(
                getDataFromPointer("/links/risikoortCreate"),
            ).then((createRisikoortResponse) => {
                const newRisikoort = {
                    ...createRisikoortResponse["_data"],
                    ...address,
                    _links: createRisikoortResponse["_data"]["_links"],
                    bezeichnung: `Risikoort ${amountOfRisikoorte + 1}`,
                }
                updateData(newRisikoort, "/risikoorte/risikoort")
                updateData(
                    [...risikoOrtListe, newRisikoort],
                    "/risikoorte/list",
                )
                getDataFromBackend(
                    newRisikoort._links.abweichungVersicherungsumfangLoad,
                    "/risikoorte/risikoort/abweichung",
                )
                return TomClient.callHallink(
                    newRisikoort["_links"].risikoortSave,
                    newRisikoort,
                )
            })
        },
        SELECT_RISIKOORT: (risikoort) => {
            updateData(
                addZoneToRisikoort(risikoort, akJson),
                `/risikoorte/risikoort`,
            )

            getDataFromBackend(
                risikoort._links.abweichungVersicherungsumfangLoad,
                "/risikoorte/risikoort/abweichung",
            )
            getDataFromBackend(
                risikoort._links.einzelschadenList,
                "/schadenereignisse/ereignislist",
            )
        },
        CREATE_EINZELSCHADEN: () => {
            const einzelschadenList = getDataFromPointer(
                "/schadenereignisse/ereignislist",
            )
            const einzelschadenListLength = einzelschadenList?.length ?? 0

            TomClient.callHallink(
                getDataFromPointer(
                    "/risikoorte/risikoort/_links/einzelschadenCreate",
                ),
                mapSchadenData(
                    getDataFromPointer("/schadenereignisse/ereignis"),
                    einzelschadenListLength,
                ),
            )
                .then(() => {
                    return TomClient.callHallink(
                        getDataFromPointer(
                            "/risikoorte/risikoort/_links/einzelschadenList",
                        ),
                    )
                })
                .then((einzelschadenListResponse) => {
                    updateData(
                        einzelschadenListResponse["_data"],
                        "/schadenereignisse/ereignislist",
                    )
                    updateData(
                        {
                            schadeninformationen: "",
                            schadenjahr: "",
                        },
                        "/schadenereignisse/ereignis",
                    )
                })
        },
        DELETE_EINZELSCHADEN: (payload) => {
            getDataFromBackend(payload._links.delete).then(() =>
                getDataFromBackend(
                    getDataFromPointer(
                        "/risikoorte/risikoort/_links/einzelschadenList",
                    ),
                    "/schadenereignisse/ereignislist",
                ),
            )
        },
        DELETE_RISIKOORT: (risikoort) => {
            getDataFromBackend(risikoort._links.risikoortDelete).then(() => {
                getDataFromBackend(
                    getDataFromPointer(
                        "/risikoorte/risikoort/_links/risikoortList",
                    ),
                    "/risikoorte/list",
                ).then((riskoortListResponse) =>
                    initRisikoortPage(
                        riskoortListResponse,
                        updateData,
                        getDataFromBackend,
                        akJson,
                    ),
                )
            })
        },
        SAVE_DECKUNG: (deckung) => {
            sendDataToBackend(deckung._links.update, deckung).then(() => {
                getDataFromBackend(
                    getDataFromPointer(
                        "/risikoorte/risikoort/_links/einzelschadenList",
                    ),
                    "/schadenereignisse/ereignislist",
                )
            })
        },
        TOGGLE_ALL_GEBAUDE_RO: ({value}) => {
            const einzelgefahrenList = getDataFromPointer(
                "/risikoorte/risikoort/abweichung/einzelgefahrList",
            )

            einzelgefahrenList.map((gefahr, index) =>
                toggleAll("GEBAEUDE", index, value),
            )
        },
        TOGGLE_ALL_INHALT_RO: ({value}) => {
            const einzelgefahrenList = getDataFromPointer(
                "/risikoorte/risikoort/abweichung/einzelgefahrList",
            )

            einzelgefahrenList.map((gefahr, index) =>
                toggleAll("INHALT", index, value),
            )
        },
        WEITER_BEREICHE: () => {
            Promise.all([
                sendDataToBackend(
                    getDataFromPointer(
                        "/risikoorte/risikoort/_links/risikoortSave",
                    ),
                    getDataFromPointer("/risikoorte/risikoort"),
                    "/risikoorte/risikoort",
                ),
                sendDataToBackend(
                    getDataFromPointer(
                        "/risikoorte/risikoort/abweichung/_links/abweichungVersicherungsumfang:update",
                    ),
                    getDataFromPointer("/risikoorte/risikoort/abweichung"),
                    "/risikoorte/risikoort/abweichung",
                ),
            ]).then(() => {
                navigate(pathBuilder(getDataFromPointer("/links/page:forward")))
            })
        },
    }
}
